import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";

import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardFooter,
  MDBBtn,
  MDBBtnGroup,
} from "mdbreact";
import { toast, ToastContainer } from "react-toastify";

import "../css/scrollbar.css";

import AccessDenied from "../components/AccessDenied";

import AddEditServiceInclusion from "./AddEditServiceInclusion";

// import AddNewSales from "./AddNewSales";

const ServiceInclusion = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [rows, setRows] = useState([]);

  const [showPreloader, setPreloader] = useState("normal");
  const [strTransactions, setTransactions] = useState("");
  const [selRow, setSelectedRow] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = (transtype) => {
    setRows([]);

    showAddEdit(!modalAddEdit);

    loadData();
  };

  const toastId = React.useRef(null);

  const notify = (message) => {
    toastId.current = toast.info(message);
  };

  const [bRefresh, setRefresh] = useState(false);

  const refreshGrid = (message) => {
    setRows([]);
    setRefresh(!bRefresh);

    loadData();
    notify(message);
  };

  const showResult = (message) => {
    setRefresh(!bRefresh);

    setRows([]);

    // loadData();

    loadData();

    toast.info(message, {
      closeButton: false,
    });
  };

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function loadData() {
    Axios.get(
      props.apiServer + "/serviceinclusionlist?parentcode=" + props.parentcode,
      bearer
    )
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function ShowDeleted() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("deleted");
    loadData();
  }

  function ShowReturns() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("returns");
    loadData();
  }

  function ShowSales() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("sales");
    loadData();
  }

  function ShowAll() {
    setPreloader("normal");
    setTransactions("");
    loadData();
  }
  const useMountEffect = (functionName) => useEffect(functionName, []);

  // useMountEffect(checkAdminAccess);
  // useMountEffect(loadData);

  useEffect(() => {
    // loadData();
    refreshGrid();
  }, [strTransactions]);

  useEffect(() => {
    // loadData();
    refreshGrid();
  }, [props.code]);

  useEffect(() => {
    // loadData();
    refreshGrid();
  }, [props.parentcode]);

  const TitleBar = () => {
    return (
      <h6
        style={{ fontFamily: "Montserrat", fontWeight: "400" }}
        className="display-5 blue-grey-text ml-1"
      >
        {" "}
        Service Inclusions
      </h6>
    );
  };

  return (
    <React.Fragment>
      <MDBRow>
        <MDBCol md="12">
          {showPreloader === "normal" ? (
            <MDBRow>
              <MDBCol md="4"></MDBCol>
              <MDBCol md="4" className="text-center">
                <br />
                <img
                  src={props.deployURL + "/loading.gif"}
                  style={{ width: "300px", textAlign: "center" }}
                  alt="loading"
                />
                <br />
              </MDBCol>
              <MDBCol md="4"></MDBCol>
            </MDBRow>
          ) : (
            <React.Fragment>
              <MDBRow>
                <MDBCol md="8">
                  <MaterialTable
                    title={<TitleBar></TitleBar>}
                    columns={[
                      { title: "", field: "code", hidden: true },

                      {
                        title: "Item / Service",
                        field: "itemdescription",
                      },

                      { title: "Qty", field: "quantity" },
                      { title: "Category", field: "itemcategory" },
                    ]}
                    data={rows}
                    options={{
                      search: true,
                      actionsColumnIndex: -1,
                      pageSize: 10,
                      pageSizeOptions: [
                        { value: rows.length, label: "All" },
                        10,
                        25,
                        50,
                        100,
                      ],
                      detailPanelType: "single",
                    }}
                    detailPanel={[
                      {
                        icon: () => (
                          <MDBIcon icon="list" className="blue-text" />
                        ),
                        openIcon: () => (
                          <MDBIcon
                            icon="chevron-circle-down"
                            className="red-text"
                          />
                        ),
                        tooltip: "Inclusion Details",
                        render: (rowData) => {
                          return (
                            <MDBContainer className="ml-0" fluid>
                              {/* <MDBCardHeader className="cloudy-knoxville-gradient">
                                <span className="font-weight-bold">
                                  {" "}
                                  Charge Details
                                </span>
                              </MDBCardHeader> */}
                              <MDBCardBody>
                                <AddEditServiceInclusion
                                  deployURL={props.deployURL}
                                  apiServer={props.apiServer}
                                  code={rowData.code}
                                  parentcode={props.parentcode}
                                  apiServerHybrid={props.apiServerHybrid}
                                  apiServerPOS={props.apiServerPOS}
                                  toggleModal={toggleAddEdit}
                                  refreshGrid={refreshGrid}
                                ></AddEditServiceInclusion>
                                {/* <ViewSales
                                  deployURL={props.deployURL}
                                  apiServer={props.apiServer}
                                  code={rowData.code}
                                  parentcode={props.parentcode}
                                  dealercode={props.dealercode}
                                  apiServerHybrid={props.apiServerHybrid}
                                  returned={false}
                                  toggleModal={toggleAddEdit}
                                  refreshGrid={refreshGrid}
                                  // refreshSalesMain={props.refreshGrid}
                                  showResult={showResult}
                                  totalSales={props.totalSales}
                                  setTotalSales={props.setTotalSales}
                                  checkTotalSales={props.checkTotalSales}
                                  opencpdnew={props.opencpdnew}
                                  discountLimit={props.discountLimit}
                                  discountInWeek={props.discountInWeek}
                                  setDiscountInWeek={props.setDiscountInWeek}
                                  getdiscountinweek={props.getdiscountinweek}
                                ></ViewSales> */}
                              </MDBCardBody>
                              <MDBCardFooter></MDBCardFooter>
                            </MDBContainer>
                          );
                        },
                      },
                    ]}
                  />
                </MDBCol>
                <MDBCol md="4">
                  <AddEditServiceInclusion
                    deployURL={props.deployURL}
                    apiServer={props.apiServer}
                    code="new"
                    parentcode={props.parentcode}
                    apiServerHybrid={props.apiServerHybrid}
                    apiServerPOS={props.apiServerPOS}
                    toggleModal={toggleAddEdit}
                    refreshGrid={refreshGrid}
                  ></AddEditServiceInclusion>
                </MDBCol>
              </MDBRow>
            </React.Fragment>
          )}
        </MDBCol>
      </MDBRow>

      <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        autoClose={2000}
      />
      {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
    </React.Fragment>
  );
};

export default ServiceInclusion;
